(function () {
  function getEligibility() {
    const element = document.getElementById('cart-sample-eligibility');

    if (!element) return {};

    try {
      return JSON.parse(element.textContent || '{}') || {};
    } catch (error) {
      console.error('Could not parse sample eligibility.', error);
      return {};
    }
  }

  function todayDateOnly() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  function formatDate(dateString) {
    if (!dateString) return '';

    const parts = dateString.split('-');

    if (parts.length !== 3) {
      return dateString;
    }

    const date = new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );

    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  function getLimitedSampleLines() {
    return Array.from(
      document.querySelectorAll(
        '#CartDrawer [data-limited-sample="true"]'
      )
    );
  }

  function getCheckoutButton() {
    return document.getElementById('CartDrawer-Checkout');
  }

  function setCheckoutState(hasErrors) {
    const button = getCheckoutButton();

    if (!button) return;

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent.trim();
    }

    if (hasErrors) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('limited-checkout-disabled');

      button.textContent = 'RESOLVE SAMPLE ISSUES TO CHECK OUT';
    } else {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('limited-checkout-disabled');

      button.textContent =
        button.dataset.originalText || 'CHECKOUT';
    }
  }

  function validateLimitedSampleCart() {
    const eligibility = getEligibility();
    const lines = getLimitedSampleLines();

    const variantTotals = {};
    const variantNames = {};

    lines.forEach(function (line) {
      const variantId = String(line.dataset.variantId || '');
      const quantity = Number(line.dataset.quantity || 0);

      if (!variantId) return;

      variantTotals[variantId] =
        (variantTotals[variantId] || 0) + quantity;

      const nameElement =
        line.querySelector('.cart-item__name');

      if (nameElement) {
        variantNames[variantId] =
          nameElement.textContent.trim();
      }
    });

    const errors = [];

    Object.keys(variantTotals).forEach(function (variantId) {
      const quantity = variantTotals[variantId];
      const productName =
        variantNames[variantId] || 'This sample';

      if (quantity > 1) {
        errors.push(
          `<strong>${productName}</strong>: Only one of each sample may be ordered. Please reduce the quantity to 1.`
        );
      }

      const eligibleAfter =
        eligibility[variantId];

      if (
        eligibleAfter &&
        eligibleAfter > todayDateOnly()
      ) {
        errors.push(
          `<strong>${productName}</strong>: You are not eligible to reorder this sample until ${formatDate(
            eligibleAfter
          )}. Please remove it from your cart to continue.`
        );
      }
    });

    const errorBox =
      document.getElementById(
        'limited-sample-cart-errors'
      );

    if (errorBox) {
      if (errors.length > 0) {
        errorBox.innerHTML = `
          <div class="limited-cart-alert">
            <div class="limited-cart-alert__title">
              YOUR CART NEEDS ATTENTION
            </div>

            <ul>
              ${errors
                .map(function (error) {
                  return `<li>${error}</li>`;
                })
                .join('')}
            </ul>

            <div class="limited-cart-alert__footer">
              Please correct the sample issue${
                errors.length > 1 ? 's' : ''
              } above before checking out.
            </div>
          </div>
        `;
      } else {
        errorBox.innerHTML = '';
      }
    }

    setCheckoutState(errors.length > 0);

    return errors.length === 0;
  }

  /*
   * Run when the page initially loads.
   */
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      setTimeout(
        validateLimitedSampleCart,
        250
      );
    }
  );

  /*
   * Recheck after quantity controls are used.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.closest(
          '#CartDrawer'
        )
      ) {
        setTimeout(
          validateLimitedSampleCart,
          500
        );
      }
    }
  );

  /*
   * Recheck after plus, minus or remove buttons.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest(
          '#CartDrawer'
        )
      ) {
        setTimeout(
          validateLimitedSampleCart,
          700
        );
      }
    }
  );

  /*
   * Shopify redraws portions of the cart drawer after
   * Ajax cart changes. Observe the drawer so validation
   * runs again after Shopify replaces its HTML.
   */
  const drawer =
    document.getElementById('CartDrawer');

  if (drawer) {
    let validationTimer;

    const observer =
      new MutationObserver(function () {
        clearTimeout(validationTimer);

        validationTimer =
          setTimeout(
            validateLimitedSampleCart,
            150
          );
      });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  /*
   * Final safety check if checkout is clicked.
   */
  document.addEventListener(
    'click',
    function (event) {
      const checkout =
        event.target.closest(
          '#CartDrawer-Checkout'
        );

      if (!checkout) return;

      const valid =
        validateLimitedSampleCart();

      if (!valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /*
   * Make validator available if we need to call it
   * manually from other theme code later.
   */
  window.validateLimitedSampleCart =
    validateLimitedSampleCart;
})();